if (!customElements.get('yr-product-slider')) {
  customElements.define(
    'yr-product-slider',
    class YrProductSlider extends HTMLElement {
      connectedCallback() {
        if (this.sliderInstance || !window.FoxTheme?.Carousel) return;

        const container = this.querySelector('.yr-figma__product-slider');
        if (!container) return;

        this.sliderInstance = new window.FoxTheme.Carousel(container, {
          slidesPerView: 'auto',
          spaceBetween: 20,
          allowTouchMove: true,
          watchOverflow: true,
          threshold: 2,
          navigation: {
            prevEl: this.querySelector('.yr-product-slider__prev'),
            nextEl: this.querySelector('.yr-product-slider__next'),
          },
          breakpoints: {
            0: { spaceBetween: 16 },
            901: { spaceBetween: 20 },
          },
        });
        this.sliderInstance.init();
      }

      disconnectedCallback() {
        if (this.sliderInstance?.slider) this.sliderInstance.slider.destroy(true, true);
        this.sliderInstance = null;
      }
    }
  );
}
